import { render, staticRenderFns } from "./ipApplyList.vue?vue&type=template&id=730c94de&scoped=true&"
import script from "./ipApplyList.vue?vue&type=script&lang=js&"
export * from "./ipApplyList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "730c94de",
  null
  
)

export default component.exports